import React from 'react';

export const BlockPostSellbox = props => {
  return (
    <div className="block welcome-sell-box">
      <div className="container">
        <h1 className={`${props.title_centered ? 'text-center' : null}`}>
          {/* {(props.icon && props.icon === 'fa-book-open') ? <FaBookOpen className="icon"/> : null} */}
          {props.icon ? <img className="icon" src={`/support-center/api${props.icon}`} /> : null}
          {props.title}
        </h1>
        {props.description ?
          <p className={`margin-top ${props.title_centered ? 'text-center' : null}`}>
            {props.description}
          </p>
          : null}
      </div>
    </div>
  )
}
